document.addEventListener("DOMContentLoaded", function () {
  const contactButton = document.querySelector(".btn_contact-fixed");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 100) {
      contactButton.classList.add("show");
    } else {
      contactButton.classList.remove("show");
    }
  });
});